import React from 'react';
import './Footer.scss';
import pkg from './../../../package.json'
const { version } = pkg

function Footer() {

  return (
    <footer>
      <div className="row">
        <div className="col-6">
          Cookie Policy - Privacy Policy
        </div>
        <div className="col-6 text-right">
          Copyright® Webidoo 2026 v.{version}
        </div>
      </div>
    </footer>
  );
}

export default Footer;